import React, { useState, useEffect, setState } from "react";
import PropTypes from "prop-types";

import { useLazyQuery } from "@apollo/client";

import { Form, Input } from "antd";
import { SyncOutlined } from "@ant-design/icons";

import { QUERY_STUDENT_PARENT1ADDRESS } from "../../../../operations/queries/forms/SIS";
import SyncSISButton from "../../../elements/formItems/SyncSISButton";

const StudentParent1AddressSIS = ({
  form,
  sis,
  id,
  initialValue,
  error,
  disabled = true,
}) => {
  const [studentSIS, setStudentSIS] = useState(initialValue);
  const [getSIS, { data, loading }] = useLazyQuery(QUERY_STUDENT_PARENT1ADDRESS);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ parent1Address: data?.student.parent1Address || "" });
    setStudentSIS(data.student.parent1Address || "");
  }, [data]);

  return (
    <Form.Item
      label="Parent #1 Address"
      name="parent1Address"
      validateStatus={error ? "error" : ""}
      help={error}
    >
      <Input
        onChange={(e) => setStudentSIS(e.target.value)}
        disabled={true}
        //addonAfter={disabled ? "" :   Change the following line to this if we want refresh button to be hidden for view-only permissions.
        addonAfter={
          <SyncSISButton
            loading={loading}
            sisValue={sis?.student.parent1Address}
            currentValue={studentSIS}
          >
            <SyncOutlined 
              onClick={() => {getSIS({ variables: { id: id } })}}
            />
          </SyncSISButton>
        }
      />
    </Form.Item>
  );
};

StudentParent1AddressSIS.propTypes = {
  form: PropTypes.object.isRequired,
  initialValue: PropTypes.string.isRequired,
  sis: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default StudentParent1AddressSIS;
